import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';

// function
import { getLoginInform } from 'function/login';

const NotificationDropdown = props => {
  const { alarm } = props || {};

  /* router info*/
  const history = useHistory();

  /* state */
  const [isAlarm, setIsAlarm] = useState(false);
  const [alarmData, setAlarmData] = useState([]);

  /* event */
  const onMovePage = (alarmType, alarmSubType, alarmStatus) => {
    /**
     * 권한 결재자인 경우 해당 페이지 이동 시
     * 상태값 결재중(3)설정
     */
    const { haccpAuth, pltCd = null } = getLoginInform();

    switch (alarmType) {
      case 1:
        // 모선정보
        history.push({
          pathname: '/haccp/mothershipInfo',
          state: {
            pltCd: pltCd,
            startDate: new Date(moment().subtract(2, 'M')),
            endDate: new Date(),
            dateDivision: '4', // 정기분석일
            mthvessStatus: 1,
            perdAnalsYn: 'N'
          }
        });
        break;
      case 2:
      case 3:
        // 한계기준이탈 결재
        history.push({
          pathname: '/haccp/monitoring/criticalLimit',
          state: {
            pltCd: pltCd,
            approvalStatus: alarmStatus,
            ctgryGrpCd: alarmSubType
          }
        });
        break;
      case 4:
        // 월말리포트 결재
        history.push({
          pathname: '/haccp/report/monthend',
          state: {
            pltCd: pltCd,
            approvalStatus: alarmStatus
          }
        });
        break;
    }
  };

  /**
   * alarm Api 호출
   * 1: 모선정기분석일 알림
   * 2: 한계기준이탈 미등록 알람
   * 3: 한계기준이탈 조치내역 알ㅇ람
   * 4: 리포트 결재 알람
   */
  const alarmRequest = async () => {
    const { alarmDatas } = alarm || {};

    const data = structuredClone(alarmDatas);

    const alarmData = data?.map(item => {
      const { alarmType } = item || {};

      item.notification = '';

      switch (alarmType) {
        case 1:
          // 모선 정기분석일 알람
          item.notification = motherShipNotification(item);
          break;
        case 2:
        case 3:
          // 한계기준이탈 미등록 알람
          // 한계기준이탈 조치내역 알람
          item.notification = limitCriteriaNotification(item);
          break;
        case 4:
          // 리포트 결재 알람
          item.notification = reportNotification(item);
          break;
      }
      return item;
    });

    setAlarmData(alarmData);
    setIsAlarm(alarmData?.length > 0);
  };

  /**
   * 모선정보 알림문구
   */
  const motherShipNotification = data => {
    const { alarmStatus, alarmCnt } = data || {};

    let notification = '';

    switch (alarmStatus) {
      case 1:
        notification = `검사의뢰를 할 원료가 [${alarmCnt}]건 있습니다.`;
        break;
      case 2:
        notification = `지정된 정기분석일 기한을 넘긴 원료가 [${alarmCnt}]건 있습니다.`;
        break;
    }

    return notification;
  };

  /**
   * 한계기준이탈 알림문구
   */
  const limitCriteriaNotification = data => {
    const { alarmStatus, alarmCnt, alarmSubType } = data || {};

    let processType = null;

    switch (alarmSubType) {
      case 'prdt':
        processType = '제품';
        break;
      case 'rwmtr':
        processType = '원료';
        break;
      case 'proc':
        processType = '공정';
        break;
    }

    let notification = '';

    switch (alarmStatus) {
      case 1:
        // 미등록
        notification = `[${processType}] 한계기준 이탈된 검사결과가 [${alarmCnt}]건 있습니다.`;
        break;
      case 2:
        // 기안중
        notification = `[${processType}] 기안 작성 중인 한계기준 이탈 조치내역이 [${alarmCnt}]건 있습니다.`;
        break;
      case 3:
        // 결재중
        notification = `[${processType}] 한계기준 이탈 조치내역 결재 요청이 [${alarmCnt}]건 있습니다.`;
        break;
      case 4:
        // 수정요청중
        notification = `[${processType}] 조치내역 수정요청이 [${alarmCnt}]건 있습니다.`;
        break;
    }

    return notification;
  };

  /**
   * 월말리포트 알림문구
   */
  const reportNotification = data => {
    const { alarmStatus, alarmCnt } = data || {};

    let notification = '';

    switch (alarmStatus) {
      case 2:
        // 기안중
        notification = `기안 작성 중인 월말 리포트가 [${alarmCnt}]건 있습니다.`;
        break;
      case 3:
        // 결재중
        notification = `월말리포트 결재 요청이 [${alarmCnt}]건 있습니다.`;
        break;
      case 4:
        // 수정요청중
        notification = `월말리포트 수정요청이 [${alarmCnt}]건 있습니다.`;
        break;
    }

    return notification;
  };

  /* watch */
  useEffect(() => {
    // alarm Api 호출
    alarmRequest();
  }, [alarm]);

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle bsPrefix="toggle" as="a">
        {isAlarm === true && (
          <FontAwesomeIcon
            icon="fa-solid fa-bell"
            className="fs-4"
            beat
            style={{ color: '#f42525' }}
          />
        )}
        {isAlarm === false && (
          <FontAwesomeIcon
            icon="fa-solid fa-bell"
            style={{ color: '#3c424e' }}
            transform="shrink-6"
            className="fs-4"
          />
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 dark__bg-1000">
          {alarmData?.map(
            ({ alarmType, notification, alarmSubType, alarmStatus }, index) => {
              return (
                <Fragment key={index}>
                  <Dropdown.Item
                    className="list-group-item bg-100"
                    onClick={() =>
                      onMovePage(alarmType, alarmSubType, alarmStatus)
                    }
                  >
                    {notification}
                  </Dropdown.Item>
                </Fragment>
              );
            }
          )}
          {isAlarm === false && (
            <Dropdown.Item>알람내역이 존재하지 않습니다.</Dropdown.Item>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;
